





















import Vue from 'vue';
import OctDepotDataTable from "@/common/components/OctDepotDataTable.vue";
import { mapGetters } from "vuex";
import {
  DEPOTS,
  SEARCH_DEPOTS,
  DepotSearchParameters,
  DEPOTS_LOADING,
  DASHBOARD_STORE
} from "@/common/store/modules/DashboardStore";

export default Vue.extend({
  name: 'OctDepotSearch',
  components: {
    OctDepotDataTable,
  },
  data: () => ({
    depotFilter: '',
  }),
  computed: {
    ...mapGetters(DASHBOARD_STORE, [DEPOTS, DEPOTS_LOADING]),
    displayResult() : boolean {
      return (!!this.depotFilter && this.depotFilter.length >= 3);
    }
  },
  watch: {
    depotFilter(newValue: String, oldValue: String) {
      if(newValue && newValue.length >= 3) {
        this.$store.dispatch(SEARCH_DEPOTS, { filter: newValue } as DepotSearchParameters);
      }
    }
  }
});
